<msd-subscription-banner (close)="closeBanner()"
                         *ngIf="bannerType !== undefined"
                         @trialBanner
                         [class]="bannerClass"
                         [remainingDays]="remainingDays"
                         [type]="bannerType">
</msd-subscription-banner>
<router-outlet></router-outlet>
